import { ReplyToCommentActionTypes } from './reply-to-comment.types';

export const openReplyToCommentPage = onComment => ({
    type: ReplyToCommentActionTypes.OPEN_REPLY_TO_COMMENT_PAGE,
    payload: onComment,
});

export const closeReplyToCommentPage = () => ({
    type: ReplyToCommentActionTypes.CLOSE_REPLY_TO_COMMENT_PAGE,
});